module.exports = __webpack_public_path__ + "media/images/icon_list/like-ee701833ca4eb29b61b29128401d3e16.svg";